export const datosFiscalesFormDefault = {
    isValid: false,
    values: {
        rfc: "",
        beneficiario: "",
        pais: "",
        estado: "",
        municipio: "",
        calle: "",
        colonia: "",
        codigoPostal: "",
        numeroExterior: "",
        correo: "",
        correo2: "",
        regimenFiscal: "",
        usoCFDI: "",
        soloGenerico: false
    },
    touched: {
        rfc: true,
        beneficiario: true,
        pais: true,
        estado: true,
        municipio: true,
        calle: true,
        colonia: true,
        codigoPostal: true,
        numeroExterior: true,
        correo: true,
        correo2: true,
        regimenFiscal: true,
        usoCFDI: true,
        soloGenerico: true
    },
    errors: {}
};

export const datosFiscalesConstraints = {
    rfc: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido'
        }
    },
    beneficiario: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    pais: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    estado: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    municipio: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    correo: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        },
        email: {
            message: "No es un correo válido."
        }
    },
    calle: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    colonia: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    codigoPostal: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    numeroExterior: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    correo2: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        },
        email: {
            message: "No es un correo válido."
        }
    },
    regimenFiscal: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    },
    usoCFDI: {
        presence: {
            allowEmpty: false,
            message: '^Campo requerido.'
        }
    }
};